import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { NotFound } from "./utils/notFound";
import { NavBar } from "./components/navigation/navBar";
import ScrollToTop from "./utils/ScrollToTop";
import { TheBook } from "./pages/TheBook";
import { Giving } from "./pages/Giving";
import { Biography } from "./pages/Biography";
import { EndowmentFund } from "./pages/EndowmentFund";
import { LifetimeEminentLeadershipAward } from "./pages/LifetimeEminentLeadershipAward";
import { DynamicMetaTags } from "./utils/dynamicMetaTags";

const defaultImage =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/ogImage-nahil-update-01-01.jpg";

function App() {
  return (
    <Router>
      <DynamicMetaTags
        ogTitle="Simply Nahil"
        ogDescription="Nahil Wijesuriya's biography, business journey and philanthropic work in Sri Lanka."
        ogImage={defaultImage}
        ogUrl="nahilwijesuriya.com"
      />
      <NavBar />
      <ScrollToTop>
        <Routes>
          <Route exact path="/" element={<TheBook />} />
          <Route exact path="/giving" element={<Giving />} />
          <Route exact path="/biography" element={<Biography />} />
          <Route
            exact
            path="/nahil-wijesuriya-endowment-fund"
            element={<EndowmentFund />}
          />
          <Route
            exact
            path="/lifetime-eminent-leadership-award-cpm-sri-lanka/"
            element={<LifetimeEminentLeadershipAward />}
          />
          <Route exact path="/*" element={<NotFound />} />
        </Routes>
      </ScrollToTop>
      {/* <Footer /> */}
    </Router>
  );
}

export default App;
